import { defineStore } from "pinia";
import { computed, reactive, ref, watch, Ref } from "vue";
import { getUserInfo, getVipInfo } from "@/../CsdPublic/user";
import { setStorage, getStorage, removeStorage } from "@/utils/storage";
import { openLoginDialog } from "@/components/Dialogues/useData/login";
import { formatTime } from "@/../CsdPublic/utils/index";
import pay from "@/../CsdPublic/pay";

// import { showMessageBoxByType } from "@/components/content/MessageBox/messageBox.ts";
import { needVip } from "@/data/pubilc";
import { ElMessage } from "element-plus";
import { showVIPDialogue } from "@/components/Dialogues/useData/useDialogues";
// import { judgeTicket } from "@/views/home/member/use/ticket";
// import { openConcern } from "@/components/content/concern/concern";

const publicStore = defineStore(
  "publicStore",
  () => {
    // 用户订阅数据
    const subscribeList = ref([]);
    const getSubscribePackageList = async () => {
      try {
        const res = await pay.getSubscribePackageList();
        return res || [];
      } catch (error) {
        return [];
      }
    };
    const getSubscribeList = async () => {
      subscribeList.value = await getSubscribePackageList();
    };
    const isLogin = ref(!!getStorage("token"));
    const userTokens: Ref<number> = ref(0);
    const userInfo = reactive({
      nickName: "--",
      uid: "000000",
      userName: "--",
      avatar: null,
      bind_phone: null, // 绑定手机号
      unionid: null, // 微信unionid
      openid: null, // 微信openid
    });
    const vipInfo = reactive({
      expiry: "--", // 过期时间
      expiryDay: 0, // 到期天数
      permanent: 0, // 0: 不是永久会员 1: 是永久会员
      points: 0, // 积分（点数）
      status: 0, // 0: 未开通 1: 已开通 2: 已过期
      soft_edition: -1,
    });

    const isVip = computed(() => vipInfo.status === 1 && isLogin.value);
    const vipUse = computed(() => (needVip ? isVip.value : isLogin.value));
    watch(
      isLogin,
      () => {
        setTimeout(() => {
          // judgeTicket();
        }, 1000);
        if (!isLogin.value) {
          // 水印的判断
          userInfo.uid = "";
          userInfo.nickName = "";
          userInfo.userName = "";
          vipInfo.points = 0;
          vipInfo.status = 0;
          vipInfo.soft_edition = -1;
          vipInfo.expiry = "--";
          localStorage.removeItem("downloadHistory");
        } else {
          if (
            window.location.href.includes("from=invite") ||
            window.location.href.includes("share_href=1")
          ) {
            // openConcern();
          }
        }
      },
      { immediate: true }
    );
    const changeUserInfo = async () => {
      if (!getStorage("token")) {
        userInfo.uid = "";
        userInfo.nickName = "";
        userInfo.userName = "";
        return;
      }
      try {
        const res = await getUserInfo();
        userInfo.nickName = res.nickname;
        userInfo.uid = res.uid;
        userInfo.userName = res.username;
        userInfo.avatar = res.avatar;
        userInfo.bind_phone = res.bind_phone;
        userInfo.unionid = res.unionid;
        userInfo.openid = res.openid;
      } catch (e: any) {
        if (e.code == 403) {
          if (!isLogin.value) return;
          // ElMessage.error("登录信息已过期，请重新登录");
          openLoginDialog();
          isLogin.value = false;
          removeStorage("token");
        }
      }
    };

    const changeVipInfo = async () => {
      if (!getStorage("token")) {
        const vipOri = {
          expiry: "--", // 过期时间
          expiryDay: 0, // 到期天数
          permanent: 0, // 0: 不是永久会员 1: 是永久会员
          points: 0, // 积分（点数）
          status: 0, // 0: 未开通 1: 已开通 2: 已过期
          soft_edition: -1,
        };
        Object.keys(vipOri).forEach((key: any) => {
          (vipInfo as any)[key] = (vipOri as any)[key];
        });
        return;
      }
      try {
        getSubscribeList();
        const res = await getVipInfo();
        // vipInfo.expiry = res.expiry;
        vipInfo.expiry = res.permanent ? "永久授权" : res.expiry.split(" ")[0];
        vipInfo.expiryDay = res.expiry_day;
        vipInfo.permanent = res.permanent;
        vipInfo.points = res.points;
        vipInfo.status = res.status;
        vipInfo.soft_edition = res.status === 1 ? res.soft_edition : -1;
        const nowTime: any = formatTime(1).split("-").join("");
        const endTime = res.expiry.split(" ")[0];
        const endTimeValue = endTime.split("-").join("");
        const vipExpiryRemind = getStorage("vipExpiryRemind");
        // 弹窗提醒 vip 即将到期，一天一次
        if (
          vipInfo.status === 1 &&
          endTimeValue - nowTime >= 0 &&
          endTimeValue - nowTime <= 7 &&
          (!vipExpiryRemind || nowTime - (vipExpiryRemind as any) > 0)
        ) {
          // showMessageBoxByType("expire", {
          //   content: `会员权益将在 <span style='color: #5865F2; font-weight:bold;'>${endTime}</span> 到期，届时将无法享受对应会员权益，现在续费立即延长会员权益`,
          // });
          setStorage("vipExpiryRemind", nowTime);
        }
      } catch (e: any) {
        if (e.code == 403) {
          if (!isLogin.value) return;
          // ElMessage.error("登录信息已过期，请重新登录");
          openLoginDialog();
          isLogin.value = false;
          removeStorage("token");
        }
      }
      getUserTokens();
    };
    const getUserTokens = async () => {
      if (!getStorage("token")) return;
      try {
        const res = await pay.getUserTokens();
        userTokens.value = res.tokens;
      } catch (error) {
        //
      }
    };
    // 用户积分数
    const userTotalPoints = computed(() => {
      return vipInfo.points + ((userTokens.value as number) || 0);
    });

    const vipDisplay = computed(() => {
      const info = vipInfo;
      // 'permanent'  => 0, //是否永久 1是 0否
      //   'status'     => 0, //状态0(未授权) 1(已授权) 2(已过期)

      if (info.status === 0) {
        return "VIP会员";
      }
      if (info.permanent === 1) {
        return "终生会员";
      }
      if (info.status === 2) {
        return "已到期";
      }
      return `到期：${info.expiry}`;
    });

    return {
      subscribeList,
      getSubscribeList,
      userTokens,
      isLogin,
      userInfo,
      vipInfo,
      isVip,
      vipUse,
      changeUserInfo,
      changeVipInfo,
      getUserTokens,
      userTotalPoints,
      vipDisplay,
    };
  },
  { persist: true }
);

export default publicStore;
